import { Mapper } from '../../../common/ddd/mapper.base';
import { IWorkingSessionsAnalyticsActivityEnum } from '../../../common/enum/working-sessions/working-sessions-analytics-activity.enum';
import { SelfDigitalWorkingHoursScoreEntity } from '../../../core/domain/entities/scores/self-digital-working-hours-score.entity';

export interface ISelfDigitalWorkingHoursScorePersistenceResponse {
  [IWorkingSessionsAnalyticsActivityEnum.TotalDuration]: number;
}

export class SelfDigitalWorkingHoursScoreMapper
  implements
    Omit<Mapper<SelfDigitalWorkingHoursScoreEntity, any>, 'toResponse'>
{
  toDomain(
    record: ISelfDigitalWorkingHoursScorePersistenceResponse
  ): SelfDigitalWorkingHoursScoreEntity {
    return SelfDigitalWorkingHoursScoreMapper.toDomain(record);
  }

  static toDomain(
    record: ISelfDigitalWorkingHoursScorePersistenceResponse
  ): SelfDigitalWorkingHoursScoreEntity {
    const entity = SelfDigitalWorkingHoursScoreEntity.create({
      workingHoursScore: Number(
        record[IWorkingSessionsAnalyticsActivityEnum.TotalDuration]
      ),
    });
    return entity;
  }
}
